import storage from '@/storage';

export default (event, app) => {
  const currentTabId = app.$store.getters['ui/tabId'];
  const submittedFrom = storage.submittedFromTabId();

  if (currentTabId === submittedFrom) {
    console.log('Order submitted from current tab, skipping.');

    return;
  }

  console.log(`Order submitted from other tab (${submittedFrom}, current: ${currentTabId}), notifying customer.`);

  app.$store.commit('store/setBroadcastMessage', {
    id: `OrderSubmitted:${submittedFrom}`,
    type: { id: 'modal' },
    header: 'Заказ оформлен!',
    message: `Заказ был оформлен в другом окне этого браузера. Закройте эту страницу или перезагрузите её для обновления данных.`,
    immediate: true,
    action: {
      button: 'Перезагрузить страницу',
      handler() {
        location.reload();
      },
    },
  });
}
